import React from 'react';
import { Link } from 'react-router-dom';
import './style.css';

export default function PostNotFound() {
    return (
        <div className="notfound-page">
            <div className="text-oops">Oops!</div>
            <div className="text-error-code">404 - PAGE NOT FOUND</div>
            <div className="error-message">Tôi không thể tìm thấy trang mà bạn yêu cầu.</div>
            <div className="text-center"><Link to="/" className="btn btn-primary fw-bold">GO TO HOMEPAGE</Link></div>
        </div>
    )
}